module.exports = __webpack_public_path__ + "static/img/hulala.457fd12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diwali/hulala.png
// module id = BGjT
// module chunks = 0